module.exports = __webpack_public_path__ + "static/media/gg.27dcb063.svg";